module.exports = __webpack_public_path__ + "static/media/PriceTag.02c46863.svg";